// extracted by mini-css-extract-plugin
export default {"container":"Rent_container__etNHK","titulo":"Rent_titulo__cAe6e"};